import { render, staticRenderFns } from "./UserInfoSummary.vue?vue&type=template&id=cd2fdaa8&scoped=true"
import script from "./UserInfoSummary.vue?vue&type=script&lang=ts"
export * from "./UserInfoSummary.vue?vue&type=script&lang=ts"
import style0 from "./UserInfoSummary.vue?vue&type=style&index=0&id=cd2fdaa8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2fdaa8",
  null
  
)

export default component.exports